import api from './api'

export const authentication = {
    login,
    identify,
    logout,
    register,
};

function login(username, password) {
    return api.post('/token/login', {username, password})
        .then(function (response) {
            if (response.data.token) {
                localStorage.setItem('orbiter_jwt', response.data.token);
                return response;
            }
        })
        .catch(function (error) {
            return Promise.reject(error);
        });
}

function identify() {
    return api.get('/token/identify')
        .then(function (response) {
            if (response.data.payload.account) {
                return response;
            }
        })
        .catch(function (error) {
            return Promise.reject(error);
        });
}

function logout() {
    localStorage.removeItem('orbiter_jwt');
}

function register(user) {
    return api.post('/users', user)
        .then(function (response) {
            return response;
        })
        .catch(function (error) {
            return Promise.reject(error);
        });
}

export default authentication